module.exports = __webpack_public_path__ + "img/banner.0d0f1bb4.png";